document.addEventListener('DOMContentLoaded', function () {
    const columstrips = document.querySelectorAll('.columstrip');
    let currentIndex = 0;

    function showColumstrip(index) {
        columstrips.forEach((columstrip, i) => {
            if (window.innerWidth <= 1199) { 
                // Apply this only on screens below 1199px
                columstrip.style.display = (i === index) ? "flex" : "none";
            } else {
                // Ensure all are visible on larger screens
                columstrip.style.display = "flex";
                columstrip.style.opacity = "1";
            }
        });
    }

    function nextColumstrip() {
        currentIndex = (currentIndex + 1) % columstrips.length;
        showColumstrip(currentIndex);
    }

    // Initial display on load
    showColumstrip(currentIndex); 

    // Change slide every 3 seconds
    setInterval(nextColumstrip, 3000);

    // Re-evaluate on window resize
    window.addEventListener('resize', function() {
        showColumstrip(currentIndex);
    });
});



// document.addEventListener('DOMContentLoaded', function () {
//     const menuToggle = document.querySelector('.header__icon--menu');
//     const searchBar = document.querySelector('.mobile-search-bar');

//     menuToggle.addEventListener('click', function () {
//         if (searchBar.style.display === 'none' || !searchBar.style.display) {
//             searchBar.style.display = 'flex';
//         } else {
//             searchBar.style.display = 'none';
//         }
//     });
// });